// extracted by mini-css-extract-plugin
module.exports = {"radio":"radio-button-moduleradio1kR","fake":"radio-button-modulefake1aj"};